import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import { Amplify } from 'aws-amplify';
import AmplifyConfigParam from './config/AmplifyConfigParam';
import { createPinia } from 'pinia';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

Amplify.configure(AmplifyConfigParam);

// Load fonts asynchronously without blocking app initialization
loadFonts().catch((error) => {
    console.warn('Font loading failed, continuing with default fonts:', error);
});

createApp(App).use(router).use(createPinia()).use(vuetify).component('Datepicker', Datepicker).mount('#app');
